import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    opt: "abc",
  };
};

const userGuideMotp = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default userGuideMotp;
